// extracted by mini-css-extract-plugin
export default {"container":"Container_container__To9l+","content":"Container_content__PD4I9"};